import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { signal, computed } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import {
  AlertService,
  AuthenticationService,
  ControlItemsService,
  ProjectControlItemService,
  ProjectService,
  TenantService,
} from '../../_services/index';

import {ControlItem, Project, ProjectControlItem} from '../../_models/index';

import {LoginHelper} from '../../helpers/index';

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import {
  SelectSingleProjectControlItemComponent
} from "../selectSingleProjectControlItem/select-single-project-control-item.component";
import {SelectMappingTemplateComponent} from "../selectMappingTemplate/select-mapping-template.component";
import {ListMessageComponent} from "../listMessage";
import {ConfirmComponent} from "../confirm";
import { Evidence } from '../../_models/evidence';

@Component({
    standalone: false,
  selector: 'control-item-component',
  templateUrl: 'mapProjectControlItems.html',
  styleUrls: ['./mapProjectControlItems.css'],
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0px',
        overflow: 'hidden',
        opacity: 0
      })),
      state('expanded', style({
        height: '*',
        opacity: 1
      })),
      transition('collapsed <=> expanded', [
        animate('300ms ease-in-out')
      ])
    ])
  ]

})

export class MapProjectControlItemsComponent implements OnInit {
  loading = false;
  projects: Project[];
  allProjectControlItems: ProjectControlItem[];
  projectControlItems: ProjectControlItem[];
  controlItems: ControlItem[];
  pairings: any[];
  pairingMap: any = {};
  proposedPairingMap: any = {};
  tenantName: string;
  projectId: number;
  project: Project;
  rowGroupMetadata: {};
  subVisible = {};
  statusSubVisible = {};
  cols : any[] = [
    {field: 'category', header: 'Current Project'},
  ];
  isMappingTemplateVisible: boolean;

  implementationStatuses: any =
    {
      0: "None",
      1: "Implemented",
      2: "Partially Implemented",
      3: "Planned",
      4: "Alternative Implementation",
      5: "Not Applicable",
      7: "Not Implemented"
      /*6: "Ongoing",*/
    };
  checkboxStates: { [key: string]: any } = {};
  selectAllChecked: { [key: string]: boolean } = {};
  selectIndeterminate: { [key: string]: boolean } = {};
  selectAllTargets: { [key: string]: boolean } = {};
  selectIndeterminateTargets: { [key: string]: boolean } = {};
  selectedICS: { [key: string]: { ICS1?: string, ICS2?: string, ICS3?: string } } = {};
  tempICS1: { [key: string]: any } = {};
  tempICS2: { [key: string]: any } = {};
  tempICS3: { [key: string]: any } = {};
  statusCols : any[] = [
    {field: 'controlItem.category', header: 'Category', width: '5%'},
    {field: 'controlItem.complianceAreaControlId', header: 'Control ID', width: '5%'},
    {field: 'implementationStatusValue', header: 'Status', width: '5%'},
  ];

  constructor(
    public route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService,
    public projectService: ProjectService,
    public alertService: AlertService,
    public controlItemsService: ControlItemsService,
    public tenantService: TenantService,
    public projectControlItemService: ProjectControlItemService) {
    this.projectId = route.snapshot.params['projectId'];
  }

  ngOnInit() {
      const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
      this.tenantName = LoginHelper.getTenantName();
    if (this.tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return;
    }

    this.tenantService.getCurrent().subscribe(p => {
      this.isMappingTemplateVisible = p.isMappingTemplateEnabled;
    });

    this.projectService.getAllShort().subscribe(a => {
      this.projects = a;
        const current = this.projects.find(p => p.projectId == this.projectId);

        this.projects = this.projects.filter(p => p.projectId != this.projectId);
      this.projects.unshift(current);
      this.project = current;
      this.projects.forEach(p => this.statusCols.push({field: 'project' + p.name, header: p.name, width: '10%'}));

      this.loadPairings();

    })

  }
  logPair(pair: any): void {
    console.log(pair);
  }
  setDefaultICS(projectControlItemId: string) {
    if (!this.selectedICS[projectControlItemId]) {
      this.selectedICS[projectControlItemId] = {
        ICS1: 'ICS1',
        ICS2: 'ICS2',
        ICS3: 'ICS3'
      };
    }
    this.cdr.detectChanges();
  }
  initializeCheckboxStates() {
    const initializeStates = (items) => {
      items.forEach(item => {
        const controlId = item.projectControlItemId.toString();
        if (!this.checkboxStates[controlId]) {
          this.checkboxStates[controlId] = {
            ics1: true,
            ics2: true,
            ics3: true,
            implementationControlStatement: true,
            controlsTesting: true,
            inheritedControls: true,
            gaps: true,
            workstream: true,
            evidence: true,
            policy: true,
            documentation: true,
            intAssessment: true,
            thirdPartySecurity: true,
            thirdPartyRisk: true,
            areaSpecific: true,
            scoring: true,
            organizationalParameters: true,
            controlOrigination: true
          };
        }
        this.tempICS1[controlId] = 'ICS1';
        this.tempICS2[controlId] = 'ICS2';
        this.tempICS3[controlId] = 'ICS3';

        this.setDefaultICS(controlId);
        this.updateSelectAllState(controlId);
        if (!this.selectedICS[controlId]) {
          this.selectedICS[controlId] = {};
        }
        if (item.subItems && item.subItems.length > 0) {
          initializeStates(item.subItems);
        }
      });
    };

    initializeStates(this.projectControlItems);


  }

  handleSelectAllTargetsChange(event: any, targets: any, controlId: string) {
    const isChecked = event.checked;
    ['ics1', 'ics2', 'ics3', 'gaps', 'evidence', 'policy', 'implementationControlStatement', 'controlsTesting', 'inheritedControls', 'workstream', 'documentation', 'intAssessment', 'thirdPartySecurity', 'thirdPartyRisk', 'areaSpecific', 'scoring', 'organizationalParameters', 'controlOrigination'].forEach(key => {
      targets[key] = isChecked;
    });
    this.updateSelectAllTargetsState(targets, controlId);
  }
  updateSelectOptions(controlId: string, field: string) {
    const options = ['ICS1', 'ICS2', 'ICS3'];
    // Object.keys(this.selectedICS).forEach(id => {
    //   if (id !== controlId) {
    //     const selectedICS = this.selectedICS[id];
    //     if (selectedICS.ICS1 && options.includes(selectedICS.ICS1)) {
    //       options.splice(options.indexOf(selectedICS.ICS1), 1);
    //     }
    //     if (selectedICS.ICS2 && options.includes(selectedICS.ICS2)) {
    //       options.splice(options.indexOf(selectedICS.ICS2), 1);
    //     }
    //     if (selectedICS.ICS3 && options.includes(selectedICS.ICS3)) {
    //       options.splice(options.indexOf(selectedICS.ICS3), 1);
    //     }
    //   }
    // });

    return options;
  }
  getSelectedICS(projectControlItemId: string, key: string) {
    return this.selectedICS[projectControlItemId]?.[key];
  }

  setSelectedICS(value: any, projectControlItemId: string, key: string) {
    if (!this.selectedICS[projectControlItemId]) {
      this.selectedICS[projectControlItemId] = {};
    }
    this.selectedICS[projectControlItemId][key] = value;
  }
  handleSelectChange(event: any, controlId: string, field: string) {
    const previousValue = this.getSelectedICS(controlId, field);
    this.setSelectedICS(event.value, controlId, field);

    // if (event.value === 'None' && previousValue) {
    //   Object.keys(this.selectedICS).forEach(id => {
    //     if (id !== controlId) {
    //       const selectedICS = this.selectedICS[id];
    //       if (selectedICS.ICS1 === previousValue) {
    //         selectedICS.ICS1 = null;
    //       }
    //       if (selectedICS.ICS2 === previousValue) {
    //         selectedICS.ICS2 = null;
    //       }
    //       if (selectedICS.ICS3 === previousValue) {
    //         selectedICS.ICS3 = null;
    //       }
    //     }
    //   });
    // }
    this.cdr.detectChanges();  }
  updateSelectAllTargetsState(targets: any, controlId: string) {
    const allChecked = ['ics1', 'ics2', 'ics3', 'gaps', 'evidence', 'policy', 'implementationControlStatement', 'controlsTesting', 'inheritedControls', 'workstream', 'documentation', 'intAssessment', 'thirdPartySecurity', 'thirdPartyRisk', 'areaSpecific', 'scoring', 'organizationalParameters', 'controlOrigination'].every(key => targets[key]);
    const allUnchecked = ['ics1', 'ics2', 'ics3', 'gaps', 'evidence', 'policy', 'implementationControlStatement', 'controlsTesting', 'inheritedControls', 'workstream', 'documentation', 'intAssessment', 'thirdPartySecurity', 'thirdPartyRisk', 'areaSpecific', 'scoring', 'organizationalParameters', 'controlOrigination'].every(key => !targets[key]);
    this.selectAllTargets[controlId] = allChecked;
    this.selectIndeterminateTargets[controlId] = !allChecked && !allUnchecked;
  }

  updateSelectAllState(controlId: string) {
    const states = Object.values(this.checkboxStates[controlId]);
    const allChecked = states.every(v => v);
    const allUnchecked = states.every(v => !v);

    this.selectAllChecked[controlId] = allChecked;
    this.selectIndeterminate[controlId] = !allChecked && !allUnchecked;
  }

  handleSelectAllChange(value: boolean, controlId: string) {
    if (!this.checkboxStates[controlId]) {
      this.checkboxStates[controlId] = {
        ics1: true,
        ics2: true,
        ics3: true,
        implementationControlStatement: true,
        controlsTesting: true,
        inheritedControls: true,
        gaps: true,
        workstream: true,
        evidence: true,
        policy: true,
        documentation: true,
        intAssessment: true,
        thirdPartySecurity: true,
        thirdPartyRisk: true,
        areaSpecific: true,
        scoring: true,
        organizationalParameters: true,
        controlOrigination: true
      };
    }

    const states = this.checkboxStates[controlId];
    Object.keys(states).forEach(key => {
      states[key] = value;
    });
    this.updateSelectAllState(controlId);
  }

  handleCheckboxChange(value: boolean, controlId: string, field: string) {
    this.checkboxStates[controlId][field] = value;
    this.updateSelectAllState(controlId);
  }

  logValue(targets: any, controlId: string) {
    // Update individual checkbox state and then update parent state
    this.updateSelectAllTargetsState(targets, controlId);
    console.log('Checkbox values:', targets);
    console.log('Compliance Area:', controlId);
  }
  loadPairings() {
    this.projectControlItemService.getAll().subscribe(
      (data: ProjectControlItem[]) => {
        this.allProjectControlItems = data;
        data.forEach(projectControlItem => {
          (<any>projectControlItem).implementationStatusValue = this.implementationStatuses[projectControlItem.implementationStatus];
        });
        this.projectControlItems = data.filter(l => l.projectId == this.projectId && !data.find(i => i.projectId == this.projectId && i.controlItem.controlItemId == l.controlItem.parentControlItemId));
        this.projectControlItems.forEach(projectControlItem => {
          let i;
          projectControlItem.subItems = data.filter(i => i.controlItem.parentControlItemId == projectControlItem.controlItem.controlItemId)
            .sort((a, b) => a.controlItem.level > b.controlItem.level ? 1 : a.controlItem.level < b.controlItem.level ? -1 :
              a.controlItem.complianceAreaControlId > b.controlItem.complianceAreaControlId ? 1 : -1);
          projectControlItem.subItemLevels = [];
            let currentLevel = "";
            for (i = 0; i < projectControlItem.subItems.length; i++)
          {
            projectControlItem.subItems[i].controlItem.hasParent = true;
            if (projectControlItem.subItems[i].controlItem.level != currentLevel)
            {
              currentLevel = projectControlItem.subItems[i].controlItem.level;
                const newSubItemLevel = {subItems: [], level: currentLevel};
                projectControlItem.subItemLevels.push(newSubItemLevel);
            }
            projectControlItem.subItemLevels[projectControlItem.subItemLevels.length - 1].subItems.push(projectControlItem.subItems[i]);
          }
        });
        this.initializeCheckboxStates();
        this.projectService.getProjectControlItemsPairings(this.tenantName).subscribe(i => {
          this.pairings = i;
          console.log("pairing",this.pairings);

          this.project.projectControlItems = data.filter(p => p.projectId == this.project.projectId);
          this.projects.forEach(p => p.projectControlItems = data.filter(p => p.projectId == this.projectId));

          this.pairingMap = {};
          this.pairings.forEach(pairing => {
            this.pairingMap[pairing.fromId] = this.pairingMap[pairing.fromId] || {total: 0, cloned: 0, mapped: 0};
            this.pairingMap[pairing.fromId][pairing.toProjectName] = this.pairingMap[pairing.fromId][pairing.toProjectName] || [];
            this.pairingMap[pairing.fromId][pairing.toProjectName].push(pairing);
            this.pairingMap[pairing.fromId].total++;
            if (pairing.isCloned)
            {
              this.pairingMap[pairing.fromId].cloned++;
            }
            else
            {
              this.pairingMap[pairing.fromId].mapped++;
            }
            const projectControlItem = <any>this.allProjectControlItems.find(p => p.projectControlItemId == pairing.fromId);
            if (projectControlItem)
            {
              projectControlItem['project' + pairing.toProjectName] = pairing.toControlItemCategory + ' - ' + pairing.toControlItemName + ' - ' + pairing.toControlItemImplementationStatus;
            }
          })
          this.calculateProposedPairings();
          this.updateRowGroupMetaData()
        })
      },
      error => {
          const errorMessage = 'An error occurred while loading project.';
          this.alertService.error(errorMessage);
      });
  }

  deletePair(id) {
    this.projectService.deletePairing(id, this.tenantName).subscribe(() => {
      this.loadPairings();
    })
  }
  saveEdit(pair) {
    const subComponents = {
      ics1: pair.ics1,
      ics2: pair.ics2,
      ics3: pair.ics3,
      implementationControlStatement: pair.implementationControlStatement,
      controlsTesting: pair.controlsTesting,
      inheritedControls: pair.inheritedControls,
      gaps: pair.gaps,
      workstream: pair.workstream,
      evidence: pair.evidence,
      policy: pair.policy,
      documentation: pair.documentation,
      intAssessment: pair.intAssessment,
      thirdPartySecurity: pair.thirdPartySecurity,
      thirdPartyRisk: pair.thirdPartyRisk,
      areaSpecific: pair.areaSpecific,
      scoring: pair.scoring,
      organizationalParameters: pair.organizationalParameters,
      controlOrigination: pair.controlOrigination
    };

    console.log('subComponents:', subComponents);
    console.log('pair:', pair);
    pair.isEditing = false;
  }

  addPair(projectControlItemId, projectId) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
        projectId: projectId,
        excludeProjectControlItemId: this.projectId == projectId ? projectControlItemId : null
      }
    };


      const dialogRef = this.dialog.open(SelectSingleProjectControlItemComponent, config);
      //this.dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.pairings = this.pairings || [];
          const existing = this.pairings.find(p => p.projectControlItemId == result.projectControlItemId);
          if (existing) {
            const fromItem = this.projectControlItems.find(i => i.projectControlItemId == existing.sourceProjectControlItemId);
            alert("This control is already mapped to receive updates from " + (this.projects.find(a => a.projectId == fromItem.projectId) || {name: "another"}).name + " Project");
          return;
        }
        const projectControlItem = <any>this.allProjectControlItems.find(p => p.projectControlItemId == projectControlItemId);

        const subComponents = {
          ics1: this.checkboxStates[projectControlItemId]?.ics1 || false,
          ics2: this.checkboxStates[projectControlItemId]?.ics2 || false,
          ics3: this.checkboxStates[projectControlItemId]?.ics3 || false,
          implementationControlStatement: this.checkboxStates[projectControlItemId]?.implementationControlStatement || false,
          controlsTesting: this.checkboxStates[projectControlItemId]?.controlsTesting || false,
          inheritedControls: this.checkboxStates[projectControlItemId]?.inheritedControls || false,
          gaps: this.checkboxStates[projectControlItemId]?.gaps || false,
          workstream: this.checkboxStates[projectControlItemId]?.workstream || false,
          evidence: this.checkboxStates[projectControlItemId]?.evidence || false,
          policy: this.checkboxStates[projectControlItemId]?.policy || false,
          documentation: this.checkboxStates[projectControlItemId]?.documentation || false,
          intAssessment: this.checkboxStates[projectControlItemId]?.intAssessment || false,
          thirdPartySecurity: this.checkboxStates[projectControlItemId]?.thirdPartySecurity || false,
          thirdPartyRisk: this.checkboxStates[projectControlItemId]?.thirdPartyRisk || false,
          areaSpecific: this.checkboxStates[projectControlItemId]?.areaSpecific || false,
          scoring: this.checkboxStates[projectControlItemId]?.scoring || false,
          organizationalParameters: this.checkboxStates[projectControlItemId]?.organizationalParameters || false,
          controlOrigination: this.checkboxStates[projectControlItemId]?.controlOrigination || false,
          selectedICS1: this.tempICS1[projectControlItemId] || 'ICS1',
          selectedICS2: this.tempICS2[projectControlItemId] || 'ICS2',
          selectedICS3: this.tempICS3[projectControlItemId] || 'ICS3',
          noOfIcsSections: projectControlItem?.noOfIcsSections,
        };
        console.log("projectControlItem", projectControlItem)
        this.projectService.addPairing(projectControlItemId, result.projectControlItemId, true, subComponents, this.tenantName).subscribe(() => {
          this.loadPairings();
        })
      }

    });
  }


  addProposedPair(fromId, toId) {
    this.pairings = this.pairings || [];
    const subComponents = {
      ics1: this.checkboxStates[fromId]?.ics1 || false,
      ics2: this.checkboxStates[fromId]?.ics2 || false,
      ics3: this.checkboxStates[fromId]?.ics3 || false,
      implementationControlStatement: this.checkboxStates[fromId]?.implementationControlStatement || false,
      controlsTesting: this.checkboxStates[fromId]?.controlsTesting || false,
      inheritedControls: this.checkboxStates[fromId]?.inheritedControls || false,
      gaps: this.checkboxStates[fromId]?.gaps || false,
      workstream: this.checkboxStates[fromId]?.workstream || false,
      evidence: this.checkboxStates[fromId]?.evidence || false,
      policy: this.checkboxStates[fromId]?.policy || false,
      documentation: this.checkboxStates[fromId]?.documentation || false,
      intAssessment: this.checkboxStates[fromId]?.intAssessment || false,
      thirdPartySecurity: this.checkboxStates[fromId]?.thirdPartySecurity || false,
      thirdPartyRisk: this.checkboxStates[fromId]?.thirdPartyRisk || false,
      areaSpecific: this.checkboxStates[fromId]?.areaSpecific || false,
      scoring: this.checkboxStates[fromId]?.scoring || false,
      organizationalParameters: this.checkboxStates[fromId]?.organizationalParameters || false,
      controlOrigination: this.checkboxStates[fromId]?.controlOrigination || false
    };
    // console.log("fromId", fromId, toId)
    // console.log("subComponents", subComponents)

    this.projectService.addPairing(fromId, toId, true, subComponents, this.tenantName).subscribe(() => {
      this.loadPairings();
    })
  }
  openControlItem() {

  }

  calculateProposedPairings() {
/*    this.proposedPairingMap = {};
    for (var i = 0; i < this.projectControlItems.length; i++) {
      for (var j = 0; j < this.projects.length; j++) {
        for (var k = 0; k < this.projects[j].projectControlItems.length; k++) {
          if (this.projectControlItems[i].controlItem.controlItemId == this.projects[j].projectControlItems[k].controlItem.broadcastControlItemId && this.projectControlItems[i].projectControlItemId != this.projects[j].projectControlItems[k].sourceProjectControlItemId) {
            this.proposedPairingMap[this.projectControlItems[i].projectControlItemId] = this.proposedPairingMap[this.projectControlItems[i].projectControlItemId] || {};
            this.proposedPairingMap[this.projectControlItems[i].projectControlItemId][this.projects[j].projectId] = this.proposedPairingMap[this.projectControlItems[i].projectControlItemId][this.projects[j].projectId] || [];
            this.proposedPairingMap[this.projectControlItems[i].projectControlItemId][this.projects[j].projectId].push({
              from: this.projectControlItems[i],
              to: this.projects[j].projectControlItems[k]
            });
          }
        }
      }
    }*/
  }

  updateRowGroupMetaData() {
      const data = this.projectControlItems;
      this.rowGroupMetadata = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.controlItem.category;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.controlItem.category;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }

  }

  selectMappingTemplate(project){
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
      }
    };


      const dialogRef = this.dialog.open(SelectMappingTemplateComponent, config);

      dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {

        this.dialog.open(ConfirmComponent, {
          data: {
            title: 'Do you wish to update relevant control values as well?',
            yes: 'Yes',
            no: 'No',
            close: 'Cancel',
            confirm: () => this.doSelectMappingTemplate(project, result, true),
            cancel: () => this.doSelectMappingTemplate(project, result, false),
          }
        });

      }

    });
  }

  doSelectMappingTemplate(project, template, apply){
    this.projectService.applyMappingTemplate(this.projectId, project.projectId, template, apply).subscribe(res => {
      let config: MatDialogConfig = {
        panelClass: 'custom-overlay-pane-class',
        width: 'auto',
        height: '90%',
        data: {
          items: res,
          title: "Import report"
        }
      };
      this.dialog.open(ListMessageComponent, config);
      this.loadPairings();
    })
  }

  applyMapping(project) {
    this.projectService.applyMapping(project.projectId).subscribe(res => {
      this.loadPairings();
    });
  }

  removeMapping(project) {
    this.projectService.removeMapping(project.projectId).subscribe(res => {
      this.loadPairings();
    });
  }
}

